import ProjectGalleryProvider, {
  useProjectGallery,
} from './project-gallery-provider';

export default ProjectGalleryProvider;
export { useProjectGallery };
